var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mx-4"},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((3),function(i){return _c('v-flex',{key:i,staticClass:"my-2",attrs:{"xs12":"","md4":""}},[_c('ChangeImage')],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }